import type { IPopupAdapter } from '../PopupAdapter'

import { PaymentButton } from 'atoms/Button/Templates'
import { TVShowPopup } from 'blocks/Popup/Templates'
import { PopupAdapter } from '../PopupAdapter'

export interface IPaymentPopupAdapter extends IPopupAdapter {
  titleButton?: string
}

export const PaymentPopupAdapter = ({
  titleButton,
  children,
  ...rest
}: IPaymentPopupAdapter) => {
  return (
    <PopupAdapter {...rest}>
      {rest.withUsingPopup ? <PaymentButton title={titleButton} /> : children}
      <TVShowPopup />
    </PopupAdapter>
  )
}
